import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-chapter-practice-tab',
  templateUrl: './chapter-practice-tab.component.html',
  styleUrls: ['./chapter-practice-tab.component.css']
})
export class ChapterPracticeTabComponent implements OnInit {

  @Input() tabSubject:string;
  tabPracticeTopicData:any;
  @Input() InteractiveStoriesList:any ;

  pypData:any;
  
  popularBookData = [
    {
      cover:'NCERT-Physics.png',
      title:'NCERT Books',
    },
    {
      cover:'RD-Sharma-maths.png',
      title: 'R.D.Sharma Mathematics',
    },
  ]

  constructor(public selfLearnService:SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    this.getExamBanners();
    this.getTopicsByChapterExamSubtenant();
    this.setPreviousPageIfFromPracticeTopics();
  }

  getTopicsByChapterExamSubtenant(){
    this.selfLearnService.getTopicsByChapterExamSubtenant().subscribe((resp:any) => {
      this.tabPracticeTopicData = resp?.data;
      this.getPracticeProgress();

    })
  }

  getPracticeProgress(){
    this.selfLearnService.getPracticeProgress().subscribe((resp:any) => {
      if(resp?.data == null) return;
      this.tabPracticeTopicData = this.tabPracticeTopicData.map((item:any, row:any) => {
      let found = resp?.data?.find((element:any) => item.topicId == element.topicId);
      if(!found){found = {};found['levelsInProgress'] = 0; found['levelsCompleted'] = 0}
      else if(!found.levelsInProgress){found.levelsInProgress = 0}
        return {...item, ...found};
      });
      console.log(this.tabPracticeTopicData);
    })
  }

  setPreviousPageIfFromPracticeTopics(){
    const previousPage = localStorage.getItem("selfLearnPreviousPage");
    if(previousPage == 'practiceTopics'){localStorage.setItem("selfLearnPreviousPage", "chapters")}
  }

  navigateToPracticeTopics(){
    localStorage.setItem('selfLearnPreviousPage' , 'practiceTopics');
    this.router.navigateByUrl('selfLearn-V2/practice-topics');
  }
  getExamBanners(){
    let payload:any ={
      "question_type": {
        "values": [
          "5f0aed9b-8b11-4653-93bc-65941bf3da3f",
          "ffc0b3e6-f1c4-45df-a302-918fda45e122",
          "ec2f3aec-e64c-11ec-8fea-0242ac120002",
          "6beee0f4-2862-49dc-b26a-4be23ee8b353",
          "20fbaaec-85fa-42be-8d10-7d442e982301"
        ],
        "is_not_enabled": false
      },
      "status": {
        "values": [
          "approved"
        ],
        "is_not_enabled": false
      },
      "previous_year": {
        "exam": null,
        "date": null
    },
      "exam_type": this.selfLearnService.getCmsExamID().toString(),
      "examType": {
        "values": [
          this.selfLearnService.getCmsExamID().toString()
        ]
      },
      "toc": {
        "subject_id": [
          this.selfLearnService.getSubjectId()
        ],
        "chapter_id": [
          this.selfLearnService.getChapterId()
        ],
        "grade": [
          //this.selfLearnService.getGradeId()
        ]
      },
      "fetchall": true
    }
    this.selfLearnService.getBannerForExams(payload).subscribe((res:any) => {
      if(res.status==true){
        this.pypData = res.data;
      }else{
        this.pypData =[];
      }
    })
  }

}
